import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useSelector, useDispatch } from "react-redux";
import {
  updateBasicField,
  addAlertEmailId,
  removeAlertEmailId,
  setBasicFormData,
} from "../../../../../features/OrgAdmin/orgAdminSlice";
import ConfigFields from "./ConfigFields";
import ExternalInfoForm from "./ExternalInfoForm";

function BasicSettingForm() {
  const dispatch = useDispatch();
  const { selectedOrg, basicFormData } = useSelector((state) => state.org);
  const [newEmail, setNewEmail] = useState("");

  // 🧩 Local states for Password and Confirm Password (only for create)
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Prefill when selectedOrg changes
  // useEffect(() => {
  //   if (selectedOrg?.orgInfo) {
  //     const org = selectedOrg.orgInfo;
  //     dispatch(
  //       setBasicFormData({
  //         orgName: org.orgName || "",
  //         orgAddress: org.address || "",
  //         phoneNumber: org.phoneNumber || "",
  //         emailId: org.emailId || "",
  //         avatar: org.avatar || "",
  //         orgShortCode: org.orgCode || "",
  //         alertEmailIds: org.alertEmailIds || [],
  //         newEmailField: (org.alertEmailIds || []).join(", "),
  //       })
  //     );
  //   } else {
  //     // Clear passwords when switching to create mode
  //     setPassword("");
  //     setConfirmPassword("");
  //   }
  // }, [selectedOrg, dispatch]);

  // BasicSettingForm.js ke useEffect ko isse replace karein

useEffect(() => {
  if (selectedOrg?.orgInfo) {
    const org = selectedOrg.orgInfo;
    
    // 🧩 Fix: Check karein ki alertEmailIds string hai ya array
    let emailArray = [];
    const rawEmails = org?.config?.alertEmailIds;

    if (Array.isArray(rawEmails)) {
      emailArray = rawEmails;
    } else if (typeof rawEmails === "string" && rawEmails.trim() !== "") {
      emailArray = rawEmails.split(",").map(email => email.trim());
    }

    dispatch(
      setBasicFormData({
        orgName: org.orgName || "",
        orgAddress: org.address || "",
        phoneNumber: org.phoneNumber || "",
        emailId: org.emailId || "",
        avatar: org.avatar || "",
        orgShortCode: org.orgCode || "",
        alertEmailIds: emailArray, 
        newEmailField: emailArray.join(", "),
      })
    );
  } else {
    // Clear passwords when switching to create mode
    setPassword("");
    setConfirmPassword("");
  }
}, [selectedOrg, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateBasicField({ field: name, value }));
  };

  const handleAddEmail = () => {
    if (newEmail.trim()) {
      dispatch(addAlertEmailId(newEmail.trim()));
      setNewEmail("");
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    dispatch(updateBasicField({ field: "password", value: e.target.value }));
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };


  return (
    <MDBox display="flex" justifyContent="center" p={2} bgcolor="#f5f6fa">
      <MDBox
        p={4}
        paddingTop="0"
        borderRadius="lg"
        bgcolor="white"
        width="30vw"
        maxWidth="600px"
        boxShadow="0 2px 8px rgba(0,0,0,0.08)"
      >
        <form
          style={{
            background: "white",
            padding: "1rem",
            borderRadius: "8px",
          }}
        >
          {!selectedOrg && (
            <>
              {/* Admin First Name */}
              <MDBox mb={3}>
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  sx={{ fontSize: "0.65rem", color: "#555" }}
                >
                  * Admin First Name :
                </MDTypography>
                <MDInput
                  fullWidth
                  required
                  size="small"
                  name="firstName"
                  value={basicFormData.firstName || ""}
                  onChange={handleChange}
                />
              </MDBox>

              {/* Admin Last Name */}
              <MDBox mb={3}>
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  sx={{ fontSize: "0.65rem", color: "#555" }}
                >
                  * Admin Last Name :
                </MDTypography>
                <MDInput
                  fullWidth
                  required
                  size="small"
                  name="lastName"
                  value={basicFormData.lastName || ""}
                  onChange={handleChange}
                />
              </MDBox>
            </>
          )}

          {/* Org Name */}
          <MDBox mb={3}>
            <MDTypography
              variant="caption"
              fontWeight="medium"
              sx={{ fontSize: "0.65rem", color: "#555" }}
            >
              * Org Name :
            </MDTypography>
            <MDInput
              fullWidth
              required
              size="small"
              name="orgName"
              value={basicFormData.orgName}
              onChange={handleChange}
            />
          </MDBox>

          {/* Address & Phone */}
          <MDBox
            mb={3}
            display="grid"
            gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
            gap={2}
          >
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ fontSize: "0.65rem", color: "#555" }}
              >
                * Org Address :
              </MDTypography>
              <MDInput
                fullWidth
                required
                size="small"
                name="orgAddress"
                value={basicFormData.orgAddress}
                onChange={handleChange}
              />
            </MDBox>
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ fontSize: "0.65rem", color: "#555" }}
              >
                * Phone Number :
              </MDTypography>
              <MDInput
                fullWidth
                required
                size="small"
                placeholder="+91"
                name="phoneNumber"
                value={basicFormData.phoneNumber}
                onChange={handleChange}
                type="number"
              />
            </MDBox>
          </MDBox>

          {/* Email */}
          <MDBox mb={3}>
            <MDTypography
              variant="caption"
              fontWeight="medium"
              sx={{ fontSize: "0.65rem", color: "#555" }}
            >
              * Org E-mail :
            </MDTypography>
            <MDInput
              fullWidth
              type="email"
              required
              size="small"
              name="emailId"
              value={basicFormData.emailId}
              onChange={handleChange}
            />
          </MDBox>

          {/* Alert Email IDs */}
          <MDBox mb={3}>
            <MDTypography
              variant="caption"
              fontWeight="medium"
              sx={{ fontSize: "0.65rem", color: "#555" }}
            >
              Alert Email IDs :
            </MDTypography>
            <MDBox display="flex" alignItems="center" gap={1} mb={2}>
              <MDInput
                fullWidth
                placeholder="Enter Alert Email ID"
                size="small"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                onKeyDown={(e) =>
                  e.key === "Enter" && (e.preventDefault(), handleAddEmail())
                }
              />
              <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={handleAddEmail}
              >
                +
              </MDButton>
            </MDBox>

            {basicFormData.alertEmailIds.map((email, index) => (
              <MDBox
                key={index}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                bgcolor="#f9fafc"
                p={1}
                borderRadius="md"
                mb={1}
              >
                <MDTypography variant="body2" sx={{ fontSize: "0.75rem" }}>
                  {email}
                </MDTypography>
                <MDButton
                  variant="text"
                  color="error"
                  size="small"
                  onClick={() => dispatch(removeAlertEmailId(index))}
                >
                  ×
                </MDButton>
              </MDBox>
            ))}
          </MDBox>

          {/* Password Fields (Only for Create Mode) */}
          {!selectedOrg && (
            <>
              <MDBox mb={3}>
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  sx={{ fontSize: "0.65rem", color: "#555" }}
                >
                  * Password :
                </MDTypography>
                <MDInput
                  fullWidth
                  required
                  size="small"
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={handlePasswordChange}
                />
              </MDBox>

              <MDBox mb={3}>
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  sx={{ fontSize: "0.65rem", color: "#555" }}
                >
                  * Confirm Password :
                </MDTypography>
                <MDInput
                  fullWidth
                  required
                  size="small"
                  type="password"
                  placeholder="Re-enter password"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                />
                {confirmPassword &&
                  confirmPassword !== password && (
                    <MDTypography
                      variant="caption"
                      color="error"
                      sx={{ fontSize: "0.65rem" }}
                    >
                      Passwords do not match
                    </MDTypography>
                  )}
              </MDBox>
            </>
          )}

          {/* Avatar & Short Code */}
          <MDBox
            mb={4}
            display="grid"
            gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
            gap={2}
          >
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ fontSize: "0.65rem", color: "#555" }}
              >
                Avatar :
              </MDTypography>
              <MDInput
                fullWidth
                size="small"
                name="avatar"
                value={basicFormData.avatar}
                onChange={handleChange}
              />
            </MDBox>
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ fontSize: "0.65rem", color: "#555" }}
              >
                Org Short Code :
              </MDTypography>
              <MDInput
                fullWidth
                size="small"
                name="orgShortCode"
                value={basicFormData.orgShortCode}
                onChange={handleChange}
              />
            </MDBox>
          </MDBox>
        </form>

        <ConfigFields />
        <ExternalInfoForm />
      </MDBox>
    </MDBox>
  );
}

export default BasicSettingForm;
